import React from 'react';

function Buoys() {
	return(
		<div className="content">
			<h1>Buoys</h1>
		</div>
	)
}

export default Buoys;